module.exports = __webpack_public_path__ + "img/motor_no61.92ffc6b3.jpg";